import { getStorageKey } from "@catchy/region-config";
import { createUseLocalStorage } from "./createUseLocalStorage.js";
import { postLocalStorageNativeMessage } from "./nativeStorageBridge.js";

export default createUseLocalStorage({ getStorageKey, postStorageMessage: postLocalStorageNativeMessage });
